import React, { useEffect, useState } from "react";
import Header from "../Navbar/page";
import { Link, useNavigate } from "react-router-dom";
import Api from "../Api/Api";
import { RingLoader } from "react-spinners";
import Sidenavar from "../Navbar/sideNav/page";
import FooterSection from "../footer/page";
function Page() {
  const [DataInstruction, setDataInstruction] = useState({});
  const [Loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const DataFatch = async () => {
    try {
      setLoading(true);
      const response = await Api.get("/user/get-all-contents");
      // console.log("trerm---->", response.data.result.filter((item) => item.title === "Instructions")[0]);
      setDataInstruction(response.data.result.filter((item) => item.title === "Instructions")[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    DataFatch();
  }, []);

  return (
    <>
      {/* <div className="preloader align-items-center justify-content-center">
        <span className="loader"></span>
      </div> */}
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <Sidenavar />
        <div className="layout">
          <main className="content"> */}
      {/* <Header /> */}
      {Loading ? (
        // <div className="preloader align-items-center justify-content-center">
        //   <span className="loader"></span>
        // </div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : !DataInstruction._id ? (
        <>
          <Header />
          <section
            className="banner-section inner-banner position-relative about"
            style={{ height: "44%" }}
          >
            <div className="shape-area">
              <img
                src="/assets/images/abs-items/bubble.png"
                className="shape-1"
                alt="icon"
              />
              <img
                src="/assets/images/abs-items/ellipse-7.png"
                className="shape-2"
                alt="icon"
              />
            </div>
            <div className="container position-relative">
              <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                  <div className="main-content">
                    <h2 className="visible-slowly-bottom display-four mb-6">
                      No Data Found
                    </h2>
                  </div>
                </div>
                {/* <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                        <div className="breadcrumb-area position-absolute end-0 bottom-0">
                          <nav aria-label="breadcrumb">
                            <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                              <li className="breadcrumb-item p-0 m-0">
                                <Link to="/">Home</Link>
                              </li>
                              <li
                                className="breadcrumb-item active"
                                aria-current="page"
                              >
                                Instructions
                              </li>
                            </ol>
                          </nav>
                        </div>
                      </div> */}
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          {/* <Header /> */}

          <section
            className="banner-section inner-banner position-relative about"
            style={{ height: "25%" }}
          >
            <div className="shape-area">
              <img
                src="/assets/images/abs-items/bubble.png"
                className="shape-1"
                alt="icon"
              />
              <img
                src="/assets/images/abs-items/ellipse-7.png"
                className="shape-2"
                alt="icon"
              />
            </div>
            <div className="container position-relative">
              <div style={{ marginTop: "9%", cursor: "pointer" }}>
                <i class="fa fa-arrow-left" onClick={() => navigate("/")}></i>
              </div>
              <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                  <div className="main-content">
                    <h2 className="visible-slowly-bottom display-four mb-6">
                      {DataInstruction.title}
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                  <div className="breadcrumb-area position-absolute end-0 bottom-0">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                        <li className="breadcrumb-item p-0 m-0">
                          <Link to="/">Home</Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Instructions
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- Banner-section end -->

    <!-- Privacy Content In start --> */}
          <section className="privacy-content" style={{ height: "52%" }}>
            <div className="pt-80 pb-80">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    {/* <div className="top-wrapper">
                            <h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </h4>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. 
                                Praesent auctor lorem vel fringilla fermentum.</p>
                            <ul>
                                <li>— Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum.</li>
                                <li>— Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum.</li>
                                <li>— Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum.</li>
                                <li>— Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum.</li>
                            </ul>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. Praesent auctor lorem vel fringilla fermentum. Phasellus consequat urna sed volutpat dignissim. Sed sagittis ex mi, in finibus lectus tempus et. Pellentesque eu porta leo. Fusce ut tempus felis.</p>
                            <div className="safe-data">
                                <h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. Praesent auctor lorem vel fringilla fermentum. Phasellus consequat urna sed volutpat dignissim. Sed sagittis ex mi, in finibus lectus tempus et. Pellentesque eu porta leo. Fusce ut tempus felis.</p>
                                <ul>
                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </li>
                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </li>
                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </li>
                                    <li> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. </li>
                                </ul>
                            </div>
                            <div className="cookies">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pharetra mattis est ut elementum. Praesent auctor lorem vel fringilla fermentum. Phasellus consequat urna sed volutpat dignissim. Sed sagittis ex mi, in finibus lectus tempus et.</p>
                            </div>
                        </div> */}
                    {Loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <RingLoader color="rgb(50 92 213)" size="100" />
                      </div>
                    ) : (
                      <>
                        {DataInstruction.description && (
                          <div
                            style={{ textAlign: "justify" }}
                            dangerouslySetInnerHTML={{
                              __html: DataInstruction.description,
                            }}
                          ></div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <FooterSection />
        </>
      )}
      {/* </main>
        </div>
      </div> */}
      {/* <!-- Create Account In end --> */}
      {/* </div> */}
    </>
  );
}

export default Page;
